<m-input-style class="m-textarea"
               :disabled="isDisabled"
               :readonly="isReadonly"
               :waiting="isWaiting"
               :error="hasTextareaError"
               :valid="isTextareaValid"
               :label="label"
               :label-id="labelId"
               :label-for="id"
               :focus="isFocus"
               :label-up="labelUp"
               :empty="isEmpty"
               :required-marker="requiredMarker"
               :tag-style="tagStyle"
               :error-message="errorMessage"
               :valid-message="validMessage"
               :helper-message="helperMessage"
               :style="{ width: inputWidth, maxWidth: inputMaxWidth }"
               @click="onClick">
    <textarea v-model="model"
              v-m-textarea-auto-height
              ref="input"
              :id="id"
              class="m-textarea__input"
              :disabled="isDisabled"
              :readonly="isReadonly || isWaiting"
              :placeholder="placeholder"
              :maxlength="maxLengthNumber"
              :autocomplete="autocomplete"
              rows="1"
              :aria-invalid="hasTextareaError"
              :aria-label="inputAriaLabel"
              :aria-describedby="inputAriaDescribedby"
              :aria-activedescendant="inputAriaActivedescendant"
              :aria-autocomplete="inputAriaAutocomplete"
              :aria-controls="inputAriaControls"
              :required="required || requiredMarker"
              :aria-required="required || requiredMarker"
              @focus="onFocus"
              @blur="onBlur"
              @change="onChange"
              @keyup="onKeyup"
              @keydown="onKeydown"
              @paste="onPaste"></textarea>
    <div slot="validation"
         :id="inputAriaDescribedby"
         class="m-textarea__validation">
        <m-validation-message class="m-textarea__validation-message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasTextareaError"
                              :valid="isTextareaValid"
                              :error-message="errorMessage"
                              :valid-message="validMessage"
                              :helper-message="helperMessage" />
        <m-character-count v-if="characterCount"
                           class="m-textarea__validation-character-count"
                           :value-length="valueLength"
                           :max-length="maxLength"
                           :threshold="characterCountThreshold" />
    </div>
</m-input-style>
